export default "__VITE_ASSET__C7L$rEjs__"